import { Checkbox, Form } from "antd";
import React from "react";

const VoucherPlatform = ({ getFieldDecorator }) => {
  return (
    <>
    <Form.Item name="pos" valuePropName="checked">
        {getFieldDecorator("show_pos", {
          valuePropName: "checked",
          initialValue: false,
        })(<Checkbox>POS</Checkbox>)}
      </Form.Item>
      <Form.Item name="website" valuePropName="checked">
        {getFieldDecorator("show_online", {
          valuePropName: "checked",
          initialValue: false,
        })(<Checkbox>Website</Checkbox>)}
      </Form.Item>
      <Form.Item name="mobile" valuePropName="checked">
        {getFieldDecorator("show_mobile", {
          valuePropName: "checked",
          initialValue: false,
        })(<Checkbox>Mobile App</Checkbox>)}
      </Form.Item>
    </>
  );
};

export default VoucherPlatform;
